




















import Vue from "vue"
import MaterialIcon, {
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    materialIconName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      iconType: {
        FILLED,
      },
    }
  },
  methods: {
    emitClickEvent() {
      this.$emit("click")
    },
  },
})
